import React, { useContext } from 'react'
import { Row, Col } from 'react-bootstrap'
import { MigrantContext } from '../../../contexts/migrantContext'
import { UserType } from '../../../contexts/authContext'
import { Link } from 'react-router-dom'

type ProfileHeaderData = {
  userType?: UserType
}

function ProfileHeader({ userType }: ProfileHeaderData) {
  const migrantContext = useContext(MigrantContext)

  return (
    <>
      <Row>
        <Col>
          <h1 className="pageTitle">Profile</h1>
        </Col>
      </Row>

      <Row>
        <Col className="text-center">
          <img
            src={migrantContext?.profile?.avatarUrl || '/profilepic.png'}
            alt="user avatar"
            className="avatar"
          />

          <h4 className="my-4">
            {migrantContext?.profile?.firstName +
              ' ' +
              migrantContext?.profile?.lastName}
          </h4>

          <Link to="/editprofile">
            <button className="mochi-button orange">Edit Profile</button>
          </Link>
        </Col>
      </Row>
    </>
  )
}

export default ProfileHeader
